import { entitySubscriptionInvoice, entitySmsBalanceInvoice } from '@/libs/acl/entities'

export default [
  {
    path: '/account/subscription',
    name: 'app-subscription',
    component: () => import('@/views/integrator/subscription/Subscription.vue'),
    meta: {
      contentClass: 'subscription-application',
      resource: entitySubscriptionInvoice,
      action: 'read',
      title: 'Subscription',
    },
  },
  {
    path: '/account/sms-balance',
    name: 'app-sms-balance',
    component: () => import('@/views/integrator/sms-balance/SmsBalance.vue'),
    meta: {
      contentClass: 'sms-balance-application',
      resource: entitySmsBalanceInvoice,
      action: 'read',
      title: 'SMS Balance',
    },
  },
]
